import { Component, OnInit } from '@angular/core';

// @ngrx
import { Store } from '@ngrx/store';

// rxjs


import * as SpinnerReducer from '@store/spinner/reducers';

@Component({
  selector: 'app-main-spinner',
  templateUrl: './main-spinner.component.html',
  styleUrls: ['./main-spinner.component.scss']
})
export class MainSpinnerComponent implements OnInit {
  status = false;
  constructor(
    private store: Store<SpinnerReducer.SpinnerState>
  ) {
  }

  ngOnInit() {
    this.store.subscribe(value => {
      if (typeof value.spinner !== 'undefined') {
        this.status = value.spinner.running;
      }
    });
  }

}
